<script>
import WidgetHiddenIcon from "./widget-hidden-icon.vue";
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";

export default {
    name: "widget-element-row",
    components: {VTooltipWrapper, WidgetHiddenIcon},
    props: {
        widget: {},
        viewPrivilege: String,
        managePrivilege: String,
        selected: Boolean
    },
    computed: {
        translations() {
            return {
                added: Lang.langGet("Added at"),
                file_name: Lang.langGet("Filename"),
                delete: Lang.langGet("Delete"),
                download: Lang.langGet("Download"),
                edit: Lang.langGet("Edit"),
            }
        }
    }
}
</script>

<template>
    <div class="widget-element-row">
        <div class="widget-element-row-cell">
            <v-btn small icon aria-label="checkbox" v-if="managePrivilege === '1' && widget.editable" @click="$emit('select')" :color="selected ? 'primary' : ''">
                <v-icon>{{ selected ? 'fa-regular fa-square-check' : 'fa-regular fa-square' }}</v-icon>
            </v-btn>
        </div>
        <div class="widget-element-row-cell">
            <widget-hidden-icon primary v-if="widget.hidden" />
        </div>
        <div class="widget-element-row-cell">
            <div class="wrap-text">
                {{ widget.showGlobalName ? '*** ' + widget.name : widget.name }}
            </div>
            <v-tooltip-wrapper :activator="'#widget-name-' + widget.id">
                {{ translations.file_name + ': ' + widget.file_name }}
            </v-tooltip-wrapper>
        </div>
        <div class="widget-element-row-cell">
            {{widget.version}}
        </div>
        <div class="widget-element-row-cell">
            {{widget.author}}
        </div>
        <div class="widget-element-row-cell">
            {{widget.description}}
            <v-tooltip-wrapper :activator="'#widget-description-' + widget.id" v-if="widget.rich_description">
                {{ widget.rich_description }}
            </v-tooltip-wrapper>
        </div>
        <div class="widget-element-row-cell">
            {{widget.created_at}}
        </div>
        <div class="widget-element-row-cell" style="text-align: end">
            <v-btn v-if="managePrivilege === '1' && widget.editable" color="primary" aria-label="download" @click="$emit('download')">
                <v-tooltip-wrapper :open-delay="350">
                    <template #activator="{ on, attrs }">
                        <div v-bind="{...$attrs, ...attrs}"
                             v-on="{...$listeners, ...on}">
                            <v-icon>fa-regular fa-download</v-icon>
                        </div>
                    </template>
                    <div class="icon-in-tooltip-container">
                        {{ translations.download }}
                    </div>
                </v-tooltip-wrapper>
            </v-btn>
            <a v-if="managePrivilege === '1' && widget.editable" :href="'/administration/widget/edit/' + widget.id">
                <v-btn color="primary" aria-label="edit">
                    <v-tooltip-wrapper :open-delay="350">
                        <template #activator="{ on, attrs }">
                            <div v-bind="{...$attrs, ...attrs}"
                                 v-on="{...$listeners, ...on}">
                                    <v-icon>fa-regular fa-pencil</v-icon>
                            </div>
                        </template>
                        <div class="icon-in-tooltip-container">
                            {{ translations.edit }}
                        </div>
                    </v-tooltip-wrapper>
                </v-btn>
            </a>
            <v-btn v-if="managePrivilege === '1' && widget.editable" color="primary" aria-label="delete" @click="$emit('delete')">
                <v-tooltip-wrapper :open-delay="350">
                    <template #activator="{ on, attrs }">
                        <div v-bind="{...$attrs, ...attrs}"
                             v-on="{...$listeners, ...on}">
                            <v-icon>fa-regular fa-trash</v-icon>
                        </div>
                    </template>
                    <div class="icon-in-tooltip-container">
                        {{ translations.delete }}
                    </div>
                </v-tooltip-wrapper>
            </v-btn>
        </div>
    </div>
</template>

<style scoped>
    .v-icon {
        font-size: 16px;
    }
</style>
